import { images } from 'styled';
import styled from 'styled-components';
import { DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { EmptyButton, parseTheme, size } from 'mol-ui';
const { logo_height } = images;

export const Container = styled.div`
    box-sizing: border-box;
    height: calc(100% - 70px);
    left: 200px;
    overflow-x: auto;
    overflow-y: auto;
    position: fixed;
    top: 70px;
    width: calc(100% - 200px);
    z-index: 1;

    ${ size.md(`
        left: 0px;
        width: 100%;
    `) }

    @media print {
      left: 100px;
      position: relative;
    }
`;

export const Avatar = styled.img`
    border-radius: 100%;
    display: inline-block;
    height: 40px;
    width: 40px;
`;

export const Divider = styled.div`
    flex: 1;
`;

export const DropdownItemStyled = styled(DropdownItem)`
    align-items: center;
    color: ${ ({ theme: { textColor } }) => textColor };
    display: flex;
    font-size: 0.9rem;
    font-weight: 500;
    padding: 10px 15px 10px 20px;
`;

export const DropdownMenuStyled = styled(DropdownMenu)`
    border: none;
    border-radius: 0;
    box-shadow: 0px 5px 15px 0px rgba(0,0,50,0.10);
    transform: none !important;
    top: 65px !important;
    left: ${ ({ right }) => right ? 'auto' : '0' } !important;
    right: ${ ({ right }) => right ? '0px' : '' } !important;
`;

export const DropdownToggleStyled = styled(DropdownToggle)`
    align-items: center;
    background-color: transparent;
    border: none;
    box-shadow: none;
    display: flex;
    font-size: 0.95rem;
    font-weight: 500;
    outline: none;

    &:active {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    &:focus{
        background-color: transparent;
        box-shadow: none;
    }

`;

export const FlagContainer = styled(EmptyButton)`
    border: 1px solid transparent;
    margin: 0px;
    padding: 0px 5px 1px 5px;
    :focus {
        ${ parseTheme('border-color', 'overPrimaryColor') }
    }
    ${ size.xs(`
        margin: 0px 0px 0px 0px;
    `) }
`;

export const IconContainer = styled.div`
    margin-left: 10px;
`;

export const Image = styled.div`
    cursor: pointer;
    display: block;

    img {
        max-height: ${ logo_height };
        padding: 5px 0px;
    }

    ${ size.md(`
        margin-right:auto;
        img {
            width: 60px;
        }
    `) }
`;

export const Nav = styled.nav`
    align-items: center;
    background-color: ${ ({ theme: { primaryColor } }) => primaryColor };
    display: flex;
    height: 70px;
    justify-content: space-between;
    padding: 0px 15px 0px 25px;
    position: fixed;
    width:100%;
    z-index: 9999;

    ${ size.md(`
        padding: 0px 15px 0px 15px;
    `) }
`;

export const MaterialContainer = styled.div`
    align-items: center;
    display: flex;
    padding: 0px 10px;
    width: 40px;
`;

export const Menu = styled.div`
    border-radius: 50%;
    height: 10px;
    margin: 0 10px 0 0;
    width: 10px;
    display: none;
    ${ size.md(`
        display: block;
    `) }
`;

export const MobileNav = styled.div`
    height: 20px;
    width: 20px;
    padding:10px;
    display:none;
    background-repeat: no-repeat;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%0D%0A%3Csvg%20width%3D%2225px%22%20height%3D%2221px%22%20viewBox%3D%220%200%2025%2021%22%20version%3D%221.1%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20xmlns%3Axlink%3D%22http%3A//www.w3.org/1999/xlink%22%3E%0D%0A%20%20%20%20%3Cg%20id%3D%22MEDICO-EXTERNO---CP%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0D%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%2201.02.04.Especialidades.Mobile%22%20transform%3D%22translate%28-13.000000%2C%20-22.000000%29%22%20fill%3D%22%23FFFFFF%22%20fill-rule%3D%22nonzero%22%3E%0D%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M13%2C22%20L38%2C22%20L38%2C25%20L13%2C25%20L13%2C22%20Z%20M13%2C31%20L38%2C31%20L38%2C34%20L13%2C34%20L13%2C31%20Z%20M13%2C40%20L38%2C40%20L38%2C43%20L13%2C43%20L13%2C40%20Z%22%20id%3D%22Combined-Shape%22%3E%3C/path%3E%0D%0A%20%20%20%20%20%20%20%20%3C/g%3E%0D%0A%20%20%20%20%3C/g%3E%0D%0A%3C/svg%3E');
    ${ size.md(`
        display: block;
    `) }
`;

export const Text = styled.div`
    margin: ${ ({ margin }) => margin || 0 };
    color: ${ ({ theme: { secondaryColor, opacityColor }, opacity }) => opacity ? opacityColor : secondaryColor };
    display: flex;
    font-size: ${ ({ size }) => size || '16px' };
    font-weight: ${ props => ('bold' in props) ? '700' : '400' };
`;

export const Content = styled.div`
  background-color: #f3f7fd;
  min-height: calc(100vh - 60px);
  margin-left: 200px;
  padding-top: 100px;
  ${ size.md(`
        margin-top: 30px;
        margin-left: 0px;
        padding: 0px;
  `) }
`;

export const TabList = styled.ul`
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: start;
  box-shadow: 0 7px 30px 0 rgba(82, 82, 107, 0.15);
`;

export const TabListItem = styled.li`
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 13px;
  margin: 0 10px;

  a {
    padding: 20px 10px;
    color: #7d96b5;
    transition: all 200ms ease;
  }

  a.active {
    color: ${ ({ theme: { primaryColor } }) => primaryColor };
  }
`;

export const TextContainer = styled.div`
  padding-top: 1px;
  width: 80%;
`;

export const Link = styled.a`
  color: ${ ({ theme: { primaryColor } }) => primaryColor };
  text-decoration: none;
`;
